module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAABOElEQVQ4jZWSTSvFQRSHHyLlJcmt280HIKVsEFtbJUt8AnVZiXwKKQsbZSlla2dpgYWFbikLQrpJXmPHo79G+Jup61dTZ6bznDlvqKkzqe6rxZRPChz2W5dqoVa4x786iwXIgyX1MQJnulA7UnAGXiXAnwGKebg51FaLql8B6rIagUOglf9ppAEYAB6ASkD7gaZImCfgGGgESsBwrNubidTn8r71kR9eEsnf5x9icCzlTC21wDUrBhcTcHv+oSHitAF0ATehzrZw30vBY8HpFXgHesM4xoFd4BQoANPAG7D5SYW2L6o3YSSr6qB6rm6p12qfuqRW1HV1Lb/b8+pOsI/UhWDPqgcBXlHL6nN+zlmjOoN9B3QHuw+4BR6BKWA0bOUvOFvRarDLwBCwDQwCM6EHy8AEcALwAVm26qSv2NdqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rightNav/right004.png
// module id = SR4T
// module chunks = 1